export const cloneCanvas = (oldCanvas, scale = 4) => {
  //create a new canvas
  var newCanvas = document.createElement("canvas");
  var context = newCanvas.getContext("2d");

  if (context) {
    //set dimensions
    newCanvas.width = oldCanvas.width * scale;
    newCanvas.height = oldCanvas.height * scale;

    context.scale(scale, scale);

    //apply the old canvas to the new one
    context.drawImage(oldCanvas, 0, 0);

    //return the new canvas
    return newCanvas;
  }
};

export const downloadCanvas = (canvasElem, filename) => {
  canvasElem.toBlob(function (blob) {
    let downloadLink = document.createElement("a");

    if (blob) {
      let url = URL.createObjectURL(blob);
      downloadLink.setAttribute("download", filename);
      downloadLink.setAttribute("href", url);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  });
};
